import {HttpClient} from '@angular/common/http';
import {ServiceBase} from '../base/service.base';
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ChallengeService extends ServiceBase {

    constructor(http: HttpClient) {
        super(http);
    }

    search(page: number = 1, model): any {
        const url = `${this.BASE_URL}/challenge/search/${page}`;
        return this.http.post(url, model);
    }

    get(id: string): any {
        const url = `${this.BASE_URL}/challenge/${id}`;
        return this.http.get(url);
    }

    create(model): any {
        const url = `${this.BASE_URL}/challenge/create`;
        return this.http.post(url, model);
    }

    update(model, id): any {
        const url = `${this.BASE_URL}/challenge/update/${id}`;
        return this.http.put(url, model);
    }

    delete(id: string, lang: string): any {
        const url = `${this.BASE_URL}/challenge/${id}/${lang}`;
        return this.http.delete(url);
    }

    upload(file, id): any {
        const url = `${this.BASE_URL}/challenge/${id}/upload`;
        return new Observable((observer) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const formData: FormData = new FormData(),
                xhr: XMLHttpRequest = new XMLHttpRequest();

            if (file != null) {
                formData.append('file', file, file.name);
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        observer.next(JSON.parse(xhr.response));
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            };

            xhr.upload.onprogress = (event) => {
                const progress = Math.round(event.loaded / event.total * 100);
            };

            xhr.open('POST', url, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.getToken());
            xhr.send(formData);
        });
    }
}
